import { schema } from 'normalizr'


const image = new schema.Entity('image')

export const user = new schema.Entity(
    'users',
    { image },
    { processStrategy: entity =>
        Object.assign({}, entity, {
            image: entity.image ? entity.image.data : null,
            avatar: entity.image ? entity.image.data.path : null,
        }) }
)

export const participant = new schema.Entity(
    'participants',
    { user },
    { processStrategy: entity =>
        Object.assign({}, entity, {
            user: entity.user ? entity.user.data : null,
            last_read: entity.last_read
                ? moment
                    .utc(entity.last_read)
                    .local()
                    .format('llll')
                : null,
        }) }
)

export const message = new schema.Entity(
    'messages',
    {},
    { processStrategy: entity =>
        Object.assign({}, entity, { created_at: moment
            .utc(entity.created_at)
            .local()
            .format('llll') }) }
)

export default new schema.Entity(
    'threads',
    {
        messages: [message],
        participants: [participant],
    },
    {
        idAttribute: 'slug',
        processStrategy: entity =>
            Object.assign({}, entity, {
                messages: entity.messages ? entity.messages.data : null,
                participants: entity.participants ? entity.participants.data : null,
            }),
    }
)
